import React from 'react';
import { Box, Typography, Chip, Stack, Divider } from '@mui/material';

class IntercomGapDisplay extends React.Component {
  static DAYS = ['mon','tue','wed','thu','fri','sat','sun'];
  static DAYLABEL = { mon:'Monday', tue:'Tuesday', wed:'Wednesday', thu:'Thursday', fri:'Friday', sat:'Saturday', sun:'Sunday' };

  parseInput(input) {
    // Accept JSON string, object, or array
    let obj = input;
    if (typeof input === 'string') {
      try { obj = JSON.parse(input); } catch { obj = null; }
    }

    // {covered, gaps:[...]}
    if (obj && typeof obj === 'object' && Array.isArray(obj.gaps)) {
      return { covered: !!obj.covered, gaps: obj.gaps };
    }

    // plain array
    if (Array.isArray(obj)) {
      return { covered: false, gaps: obj };
    }

    return { covered: false, gaps: [] };
  }

  render() {
    const { covered, gaps } = this.parseInput(this.props.gaps);

    if (covered || gaps.length === 0) {
      return (
        <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#e8f5e9', border: '1px solid #c8e6c9' }}>
          <Typography variant="body1" color="success.main">✅ All hours are covered (24/7)</Typography>
        </Box>
      );
    }

    // group by day in Mon→Sun order
    const grouped = IntercomGapDisplay.DAYS.reduce((acc, d) => (acc[d] = [], acc), {});
    for (const g of gaps) {
      const d = (g.day || '').toLowerCase();
      if (grouped[d]) grouped[d].push(g);
    }
    const daysToShow = IntercomGapDisplay.DAYS.filter(d => grouped[d].length);

    return (
      <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#fff8e1', border: '1px solid #ffe082' }}>
        <Typography variant="subtitle1" gutterBottom>⏰ Gaps in coverage:</Typography>

        {daysToShow.map((day, idx) => (
          <Box key={day} sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
              {IntercomGapDisplay.DAYLABEL[day]}
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {grouped[day].map((gap, i) => (
                <Chip
                  key={`${day}-${i}`}
                  label={`${gap.start} → ${gap.end}`}
                  color="error"
                  variant="outlined"
                  size="small"
                  sx={{ fontWeight: 500, borderColor: '#ef9a9a', color: '#c62828', bgcolor: '#ffebee' }}
                />
              ))}
            </Stack>

            {idx < daysToShow.length - 1 && <Divider sx={{ my: 1.2 }} />}
          </Box>
        ))}
      </Box>
    );
  }
}

export default IntercomGapDisplay;
